import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Close20 from '@carbon/icons-react/es/close/20';
// eslint-disable-next-line no-restricted-imports
import { Modal as AntModal } from 'antd';
import _ from 'lodash';
import { useMemo } from 'react';
import styled from 'styled-components';
import { ProductiveHeading05 } from 'components/styles';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { useTranslate } from 'hooks/use-translation';
import { IconShell } from '../icon-shell';
import * as styles from './modal.module.css';
const ModalCloseIcon = ()=>{
    const isNew = useAntdRlUISwitcher();
    return /*#__PURE__*/ _jsx(IconShell, {
        size: isNew ? 'small' : 'large',
        icon: /*#__PURE__*/ _jsx(Close20, {})
    });
};
export const defaultModalProps = {
    okButtonProps: {
        className: styles.ok_button,
        type: 'primary'
    },
    cancelButtonProps: {
        className: styles.cancel_button
    },
    closeIcon: /*#__PURE__*/ _jsx(ModalCloseIcon, {})
};
// Dont use merge function, it is costly and introduces performance issues
export const ModalBase = styled(AntModal).attrs((props)=>{
    var _props_okButtonProps, _props_okButtonProps1, _props_okButtonProps2, _props_cancelButtonProps, _props_cancelButtonProps1;
    _.set(props, 'okButtonProps.className', `${styles.ok_button} ${props === null || props === void 0 ? void 0 : (_props_okButtonProps = props.okButtonProps) === null || _props_okButtonProps === void 0 ? void 0 : _props_okButtonProps.className}`);
    if (!(props === null || props === void 0 ? void 0 : (_props_okButtonProps1 = props.okButtonProps) === null || _props_okButtonProps1 === void 0 ? void 0 : _props_okButtonProps1.type)) {
        _.set(props, 'okButtonProps.type', 'primary');
    }
    if (!(props === null || props === void 0 ? void 0 : (_props_okButtonProps2 = props.okButtonProps) === null || _props_okButtonProps2 === void 0 ? void 0 : _props_okButtonProps2['data-cy'])) {
        _.set(props, 'okButtonProps.data-cy', 'modal.ok.button');
    }
    _.set(props, 'cancelButtonProps.className', `${styles.cancel_button} ${props === null || props === void 0 ? void 0 : (_props_cancelButtonProps = props.cancelButtonProps) === null || _props_cancelButtonProps === void 0 ? void 0 : _props_cancelButtonProps.className}`);
    if (!(props === null || props === void 0 ? void 0 : (_props_cancelButtonProps1 = props.cancelButtonProps) === null || _props_cancelButtonProps1 === void 0 ? void 0 : _props_cancelButtonProps1['data-cy'])) {
        _.set(props, 'cancelButtonProps.data-cy', 'modal.cancel.button');
    }
    if (!(props === null || props === void 0 ? void 0 : props.closeIcon)) {
        _.set(props, 'closeIcon', /*#__PURE__*/ _jsx(ModalCloseIcon, {}));
    }
    return props;
})`
  .ant-modal-header {
    padding: var(--spacing-05);
    border: none;
    :root[data-new-theme-enabled='true'] & {
      position: relative;
    }

    .ant-modal-title {
      ${ProductiveHeading05};
    }
  }
  .ant-modal-body {
    padding: 0 var(--spacing-05);
    width: 100%;
  }

  .ant-modal-footer {
    padding: var(--spacing-09) var(--spacing-05) var(--spacing-05);
    border: none;
  }

  .ant-modal-close {
    :root[data-new-theme-enabled='true'] & {
      position: absolute;
      top: 14px;
      right: var(--spacing-05);
    }
  }

  .ant-modal-close-x {
    :root[data-new-theme-enabled='true'] & {
      width: 32px;
      height: 32px;
    }
    width: 48px;
    height: 48px;
    &:hover {
      background-color: var(--hover-color);
      :root[data-new-theme-enabled='true'] & {
        border-radius: 8px;
      }
    }
  }
`;
export const Modal = (props)=>{
    const t = useTranslate();
    const { cancelText: _cancelText, okText: _okText, ...rest } = props;
    const cancelText = useMemo(()=>_cancelText !== undefined ? _cancelText : /*#__PURE__*/ _jsx(_Fragment, {
            children: t('cancel')
        }), [
        _cancelText,
        t
    ]);
    const okText = useMemo(()=>_okText !== undefined ? _okText : /*#__PURE__*/ _jsx(_Fragment, {
            children: t('ok')
        }), [
        _okText,
        t
    ]);
    return /*#__PURE__*/ _jsx(ModalBase, {
        ...rest,
        cancelText: cancelText,
        okText: okText
    });
};
